import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const apuracaoNotaRoutes: RouteRecordRaw[] = [
    {
        path: "/apuracao-nota",
        name: "apuracao-nota",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTAR_APURACAO},
        component: () => import("@/modules/apuracaoNota/pages/PageApuracaoNota.vue")
    },
];
